module.exports = __webpack_public_path__ + "img/ic_tag_asset_id.3f263d52.svg";